const createVariable = (id, label) => ({
  id,
  label,
  format() {
    return formatToken(this.id)
  }
})

export function formatToken(id) {
  return `{{${id}}}`
}

export const VARIABLE_TOKEN_PATTERN = /\{\{(\w+)\}\}/g

export function removeVariableTagSpans(html) {
  return html.replace(/<span\s+class=["']variable-tag["']>([\s\S]*?)<\/span>/g, '$1')
}

export const VARIABLE_CATALOG = {
  foiSecondaryId: createVariable('foiSecondaryId', 'FOI ID'),
  requestorName: createVariable('requestorName', 'Requestor Name'),
  requestorFirstName: createVariable('requestorFirstName', 'Requestor First Name'),
  requestorLastName: createVariable('requestorLastName', 'Requestor Last Name'),
  requestorAddress: createVariable('requestorAddress', 'Requestor Address'),
  requestorEmail: createVariable('requestorEmail', 'Requestor Email'),
  acceptedDate: createVariable('acceptedDate', 'Accepted Date'),
  requestDescription: createVariable('requestDescription', 'Request Description'),
  cityName: createVariable('cityName', 'City name'),
  address: createVariable('address', 'Address'),
  mailingAddress: createVariable('mailingAddress', 'Mailing address'),
  inPersonPaymentMethod: createVariable('inPersonPaymentMethod', 'In-person payment methods'),
  hours: createVariable('hours', 'Business hours'),
  feePaymentLink: createVariable('feePaymentLink', 'Online payment link'),
  paymentDueDate: createVariable('paymentDueDate', 'Payment due date')
}

export const DEFAULT_LETTER_HEADER = `
<p>File: <span class="variable-tag">{{foiSecondaryId}}</span></p>
<p><span class="variable-tag">{{requestorFirstName}}</span> <span class="variable-tag">{{requestorLastName}}</span></p>
<p><span class="variable-tag">{{requestorAddress}}</span></p>
<p><span class="variable-tag">{{requestorEmail}}</span></p>
<p></p>
<p>Dear <span class="variable-tag">{{requestorFirstName}}</span>,</p>
<p></p>
<p><strong>RE: </strong>Request for Access to Records Under the Freedom of Information and Protection of Privacy Act</p>
<p>____________________________________________________________________________________________________________</p>
<p></p>
<p><strong>Request: </strong>Confirmed by the City of <span class="variable-tag">{{cityName}}</span> on <span class="variable-tag">{{acceptedDate}}</span>, for:</p>
<p>“<span class="variable-tag">{{requestDescription}}</span>”</p>
`.trim()

export const DEFAULT_FEE_ATTACHMENT_BODY = `
<p><strong>Completing Payment:</strong></p>
<p></p>
<p>Payment can be made by one of the following methods:</p>
<p></p>
<p><strong>Online:</strong> <span class="variable-tag">{{feePaymentLink}}</span></p>
<p><strong>Cheque payable to:</strong> <span class="variable-tag">{{cityName}}</span></p>
<p><strong>Mailed to the following address:</strong> <span class="variable-tag">{{mailingAddress}}</span></p>
<p><strong>In Person:</strong> <span class="variable-tag">{{address}}</span>, by <span class="variable-tag">{{inPersonPaymentMethod}}</span>. (<span class="variable-tag">{{hours}}</span>)</p>
<p></p>
<p>Please bring a copy of your fee estimate for in-person payment.</p>
<p></p>
<p>If we do not hear from you by <span class="variable-tag">{{paymentDueDate}}</span> we will consider your request abandoned and close the file.</p>
`.trim()
